// import { CKEDITOR_CONFIG, PAGE_SIZE_CELL, THS, THSObj } from '@/subjects/constant';
import {
  Message
} from 'element-ui';
import {
  setObjectiveHeight,
  studentMsgEffect
} from '@/utils/common';
import answerPanel from './answerPanel';
import {
  PAGE_SIZE_CELL,
  PAGE_CELL_HEIGHT,
  THS,
  THSObj,
  CONTENT_HEIGHT,
  PAGE_LAYOUT_TOP,
  STATE_KEY,
} from '@/subjects/constant';

import {
  toogleScore
} from '@/utils/common';
const TH_HEIGHT = 40; //标题高度
const state = {
  // 当前鼠标所在页码
  currentPageNum: 0,
  currentIndexInPage: 0, // 用来找当前页面的stack题型下标
  // 新生成的题目高度
  newTopicHeight: 0,
  existStack: [], // 在add之前就已经
  existHeight: 0,
  answerTopicAdded: [], // 弹窗新增的解答题列表
  answerSignal: false, // 用来阻止重复创建answer组件的
  blankSignal: false,
  writeSignal: false,
  //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
  topticType: 1,
  loadingInstance: undefined,
  // 答题卡纸张数据
  subjects: JSON.parse(sessionStorage.getItem('subjects')) || [],
  THS: THS,
  pageCellCopy: undefined,
  pageCellString: '', // 只在预览关闭时使用 用来存储当前的页面数据
  pageCell: [{
    //  答题卡页面的布局
    layout: {
      width: PAGE_SIZE_CELL[0],
      height: PAGE_CELL_HEIGHT,
      position: 'absolute',
      top: 10,
      left: '50%',
      padding: '80px 44px',
      marginLeft: -353,
    },
    // 每种题型的内容高度（就是去除纸张上面考生信息的高度）
    contentHeight: CONTENT_HEIGHT,
    canFillHeight: 0,
    items: [],
    // 填空题
    fillTopiclist: [],
  }, ],
  examination: [{
    th: '1',
    type: 2,
    score: 20,
  }, ],
  // 填空题数组
  fillTopiclist: [{
    ckEditorData: '<h1>哈哈哈</h1>',
    editorConfig: {
      //plugins: [ heightline],
      toolbar: [
        // "heading",
        //"heightline",
        'Bold',
        'Italic',
        'Underline',
        'Alignment',
        'Subscript',
        'Superscript',
        'SpecialCharacters',
        //"SpecialCharactersCurrency",
        //"SpecialCharactersMathematical",
        'MathType',
        'Link',
        'BlockQuote',
        'BulletedList',
        'NumberedList',
        'ImageUpload',
        'InsertTable',
        'Undo',
        'Redo',
      ],
      heading: {
        options: [{
            model: 'paragraph',
            title: '标准',
            class: 'ck-heading_paragraph'
          },
          {
            model: 'heading1',
            view: 'h1',
            title: 'h1',
            class: 'ck-heading_heading1',
          },
          {
            model: 'heading2',
            view: 'h2',
            title: 'h2',
            class: 'ck-heading_heading2',
          },
        ],
      },
    },
  }, ],
  // 学科和学段
  // kMAndPeriod: {
  //   km: [],
  //   period: [],
  //   ksType: []
  // },
  kMAndPeriod: null,
  basicsCheckList: ['姓名', '学校', '班级', '考号'],
};
const mutations = {
  setPageCellString: (state, payload) => {
    state.pageCellString = payload;
  },
  setPageCell: (state, payload) => {
    if (typeof payload == 'string') {
      payload && (state.pageCell = JSON.parse(payload));
    } else {
      state.pageCell = JSON.parse(JSON.stringify(payload));
    }
  },
  setSubjects: (state, payload) => {
    state.subjects = payload;
  },
  setkMAndPeriod: (state, payload) => {

    state.kMAndPeriod = payload

    localStorage.setItem(STATE_KEY.APP_KM_KEY, JSON.stringify(payload))

  },
  setBasicsCheckList: (state, payload) => {
    state.basicsCheckList = payload;
  },
  addPageCell: (state, paylod) => {
    state.pageCell = [...state.pageCell, paylod];
  },
  updatePageCell: (state, data) => {
    const {
      currentIndexInPage,
      initDragHeight,
      currentPageNumWhenFocus, // 这个代表用户手动输入题型的标题 需要存一下当前输入标题的下标
      innerHTML,
      editName,
    } = data;
    let stack = {};
    if (currentPageNumWhenFocus || currentPageNumWhenFocus === 0) {
      stack = state.pageCell[currentPageNumWhenFocus].fillTopiclist[currentIndexInPage];
    } else {
      stack = state.pageCell[state.currentPageNum].fillTopiclist[currentIndexInPage];
    }

    stack && (stack.initDragHeight = initDragHeight);
    stack && innerHTML && (stack.innerHTML = innerHTML);
    if (editName) {
      stack && (stack.editName = editName);
    }
    // state.subjects;
  },
  setTHS: (state, data) => {
    state.THS = JSON.parse(JSON.stringify(data));
  },
  setCurrentPageNum: (state, paylod) => {
    state.currentPageNum = paylod;
  },
  setCurrentIndexInPage: (state, paylod) => {
    state.currentIndexInPage = paylod;
  },
  setAnswerSignal: (state, data) => {
    state.answerSignal = data;
  },
  setBlankSignal: (state, data) => {
    state.blankSignal = data;
  },
  setTopicSignal(state, data) {
    state[data.type] = data.result;
  },
  addSubjectToPageCell: (state, paylod) => {},
  changePageWidthByHurlde: (state, payload) => {
    state.pageCell.forEach(page => {
      page.layout &&
        (page.layout.width = payload.acCardPanes == 3 ? PAGE_SIZE_CELL[1] : PAGE_SIZE_CELL[0]);
      //布局：1、一栏，2、二栏，3三栏
    });
  },
  append: async (state, data) => {
    if (state.pageCell.length >= 25) {
      Message({
        message: '答题卡页码不能超过25栏！',
        type: 'warning',
        duration: 3 * 1000,
      });
      return;
    }
    // console.log('append====log', state.pageHeight, state.newTopicHeight);
    if (data) {
      await data.render();
      state.existHeight = 0;

      function getDomExistHeight() {
        const pageCells = document.querySelectorAll('.page-cell');
        const curtPageCell = pageCells.length && pageCells[state.pageCell.length - 1];
        const arrTopicWrappers = Array.from(curtPageCell.querySelectorAll('.topic-wrapper'));
        arrTopicWrappers &&
          arrTopicWrappers.length &&
          arrTopicWrappers.forEach(el => {
            state.existHeight += el.offsetHeight || 0;
          });
      }
      getDomExistHeight();
      if (state.pageCell[state.pageCell.length - 1].fillTopiclist.length) {
        // 计算已经存在的题型高度
        // state.pageCell[state.pageCell.length - 1].fillTopiclist.forEach(item => {
        //   state.existHeight += item.initDragHeight + (item.hasTitle ? TH_HEIGHT : 0); // 解答题不需要TH_HEIGHT高度 没有头部
        //   console.log('循环i', item.initDragHeight + TH_HEIGHT, state.existHeight);
        //   // state.existHeight += item.initDragHeight + TH_HEIGHT; // 解答题不需要TH_HEIGHT高度 没有头部
        // });
        state.existStack = state.pageCell[state.pageCell.length - 1].fillTopiclist;
      } else {
        state.existHeight = 0;
      }
      data.historyTH = data.th;
      // data.indexInSubjects = state.subjects.length; //用于edit box 编辑删除当前的题型
      state.subjects.push(data);
      data.thIndex = state.THS.indexOf(data.historyTH);
      state.THS.splice(data.thIndex, 1);
      data.appendToPage(state, state.pageHeight, state.newTopicHeight);
      if (data.type != 2) {
        return;
      } else {
        const newData = await setObjectiveHeight(data);
        data.rowHeightList = newData && newData.rowHeightList;
        // state.subjects.push(data);
        newData &&
          answerPanel.state &&
          answerPanel.state.answerSheet &&
          mutations.resetPageCell(state, {
            index: state.subjects.length - 1,
            acCardPanes: answerPanel.state.answerSheet.acCardPanes,
          });
      }
    }
  },
  // 两栏三栏之后重新渲染页面
  resetPageCell: (state, data) => {
    const {
      acCardPanes,
      index,
      byDel,
      deleteTH,
      hurdleReset,
      acCardStudentCodeType
    } = data; // 如果index是0的话说明编辑的是当前的subjects中第一题 所以全部要重绘一遍 否则则按照index上面的题型保留
    // alert(index);
    console.log('reset=============================', data);
    state.currentPageNum = 0;
    // 新生成的题目高度
    state.newTopicHeight = 0;
    if (index != 0 && index != undefined) {
      let editTopicTH = undefined;
      if (deleteTH) {
        editTopicTH = deleteTH;
      } else {
        editTopicTH = byDel ?
          state.subjects[index].th :
          state.subjects[index].historyTH ?
          state.subjects[index].historyTH :
          state.subjects[index].th; //当前编辑题型的题号（这个编辑必须有题号 如果没有历史题号 则采用th）
      }
      let cachePageCell = [];
      let mypageIndex = 0;
      let mytopicIndex = 0;
      let stopLoop = false;
      state.pageCell.forEach((page, pageIndex) => {
        page.fillTopiclist.forEach((topic, topicIndex) => {
          if (topic.th == editTopicTH && !stopLoop) {
            stopLoop = true;
            mypageIndex = pageIndex;
            mytopicIndex = topicIndex;
          }
        });
        acCardStudentCodeType && (page.contentHeight = getContentHeight(acCardStudentCodeType))
      });
      state.pageCell.splice(mypageIndex + 1);
      state.pageCell[mypageIndex] && state.pageCell[mypageIndex].fillTopiclist.splice(mytopicIndex);
      if (state.pageCell[mypageIndex].fillTopiclist.length <= 0) {
        // 空白页情况下 topic length长度为0
        state.pageCell.splice(mypageIndex, 1);
      }
    } else {
      state.pageCell = [{
        //  答题卡页面的布局
        layout: {
          width: acCardPanes == 3 ? PAGE_SIZE_CELL[1] : PAGE_SIZE_CELL[0],
          height: PAGE_CELL_HEIGHT,
          position: 'absolute',
          top: 10,
          left: '50%',
          padding: '62px 44px',
          marginLeft: -353,
        },
        // 每种题型的内容高度（就是去除纸张上面考生信息的高度）
        contentHeight: getContentHeight(acCardStudentCodeType) || CONTENT_HEIGHT,
        items: [],
        // 填空题
        fillTopiclist: [],
      }, ];
    }
    (async () => {
      for (let j = 0; j < state.subjects.length; j++) {
        if (j >= (index || 0)) {
          await state.subjects[j].render({
            hurdleReset: hurdleReset
          });
          const obj = state.subjects;
          // state.subjects = [];
          state.subjects = obj;
          state.existHeight = 0;
          state.existStack = []; // 在add之前就已经
          state.answerTopicAdded = [];

          function getDomExistHeight() {
            const pageCells = document.querySelectorAll('.page-cell');
            const curtPageCell = pageCells.length && pageCells[state.pageCell.length - 1];
            const arrTopicWrappers = curtPageCell ? Array.from(curtPageCell.querySelectorAll('.topic-wrapper')) : null;
            arrTopicWrappers &&
              arrTopicWrappers.length &&
              arrTopicWrappers.forEach(el => {
                state.existHeight += el.offsetHeight || 0;
              });
          }
          getDomExistHeight();
          if (
            state.pageCell[state.pageCell.length - 1] &&
            state.pageCell[state.pageCell.length - 1].fillTopiclist.length
          ) {
            // 计算已经存在的题型高度
            // state.pageCell[state.pageCell.length - 1].fillTopiclist.forEach(item => {
            //   state.existHeight += item.initDragHeight + (item.hasTitle ? TH_HEIGHT : 0); // 解答题不需要TH_HEIGHT高度 没有头部
            //   // state.existHeight += item.initDragHeight;
            //   // state.existHeight += item.initDragHeight + TH_HEIGHT;
            //   // state.existHeight += item.initDragHeight + (item.type == 3 ? 0 : TH_HEIGHT); // 解答题不需要TH_HEIGHT高度 没有头部
            // });
            state.existStack = state.pageCell[state.pageCell.length - 1].fillTopiclist;
          } else {
            state.existHeight = 0;
          }
          await state.subjects[j].appendToPage(state, state.pageHeight, state.newTopicHeight);
        }
      }
    })();
    studentMsgEffect();
    // state.subjects.forEach(async (subject, index) => {
    // });
  },
  restorePageCell: (state, data) => {
    const {
      pageCell,
      subjects,
      acCardStudentCodeType
    } = data;
    state.pageCell = pageCell || state.pageCell || [{
      //  答题卡页面的布局
      layout: {
        width: PAGE_SIZE_CELL[0],
        height: PAGE_CELL_HEIGHT,
        position: 'absolute',
        top: 10,
        left: '50%',
        padding: '62px 44px',
        marginLeft: -353,
      },
      // 每种题型的内容高度（就是去除纸张上面考生信息的高度）
      contentHeight: getContentHeight(acCardStudentCodeType) || CONTENT_HEIGHT,
      items: [],
      // 填空题
      fillTopiclist: [],
    }, ];

    state.subjects = subjects || [];
  },
  // 预览重新更改布局
  resetPosition: (state, data) => {
    state.pageCellCopy = JSON.parse(JSON.stringify(state.pageCell));
    console.log('resetPosition=========', state.pageCellCopy);
    if (data.acCardPanes == 2) {
      state.pageCellCopy.forEach((page, index) => {
        page.layout.top = PAGE_LAYOUT_TOP * Math.floor(index / 2);
        page.layout.marginLeft = 0;
        page.layout.left = index % 2 ? '50%' : 0;
        // 给答题卡外面套一个边框
        page.layout.padding = '80px 44px 62px 44px';
        if (index % 2 == 0) {
          page.layout.padding = '80px 44px 62px 62px';
          page.layout.borderLeft = '50px';
        } else if (index % 2 == 1) {
          page.layout.padding = '80px 62px 62px 26px';
          page.layout.borderLeft = '14px';
        }
      });
    } else if (data.acCardPanes == 3) {
      state.pageCellCopy.forEach((page, index) => {
        page.layout.top = PAGE_LAYOUT_TOP * Math.floor(index / 3);
        page.layout.marginLeft = 611 * (index % 3);
        page.layout.height = PAGE_CELL_HEIGHT;
        page.layout.left = 0;
        if (index % 3 == 0) {
          page.layout.padding = '80px 64px 62px 64px';
          page.layout.borderLeft = '53px';
        } else if (index % 3 == 1) {
          page.layout.padding = '80px 22px 62px 22px';
          page.layout.borderLeft = '11px';
        } else if (index % 3 == 2) {
          page.layout.padding = '80px 64px 62px 42px';
          page.layout.marginLeft = 611 * (index % 3) - 62;
          page.layout.borderLeft = '31px';
        }
        // 0 1 2
        // 3 4 5   3n-1
        // 6 7 8
      });
    } else {

      state.pageCellCopy = JSON.parse(JSON.stringify(state.pageCell));
      state.pageCellCopy.forEach((page, index) => {
        page.layout.padding = '80px 44px 62px 44px';
        page.layout.top = PAGE_LAYOUT_TOP * Math.floor(index);
        page.layout.marginLeft = 0;
        page.layout.left = 0;
        page.layout.borderLeft = '32px';
        // page.layout.height = page.layout.height - \
        // page = answerObjective(page)
      });
    }
  },

  //重新计算题型高度
  resetPageCellContentHeight(state, data) {
    let {
      acCardStudentCodeType
    } = data
    state.pageCell.forEach(cell => {
      cell.contentHeight = getContentHeight(acCardStudentCodeType) || CONTENT_HEIGHT
    })
  },
  //预览重新计算布局
  resetPreviewLayout(state) {
    state.existHeight = 0;

    function getDomExistHeight() {
      const pageCells = document.querySelectorAll('.page-cell');
      const curtPageCell = pageCells.length && pageCells[state.pageCell.length - 1];
      const arrTopicWrappers = Array.from(curtPageCell.querySelectorAll('.topic-wrapper'));
      arrTopicWrappers &&
        arrTopicWrappers.length &&
        arrTopicWrappers.forEach(el => {
          state.existHeight += el.offsetHeight || 0;
        });
    }
    getDomExistHeight();
  },
  //  关闭预览重新渲染视图
  returnPosition: state => {},
  deleteSubject: (state, index) => {
    const subject = state.subjects[index];
    state.THS.splice(subject.thIndex, 0, subject.th);
    state.THS = [...new Set(state.THS)].sort((a, b) => {
      return THSObj[a] - THSObj[b];
    });
    state.subjects.splice(index, 1);
  },
  updateSubjects: (state, payload) => {
    console.log('updateSubjects==========----log', payload);
    const {
      index,
      data
    } = payload;
    // //  合并客观题
    // if(data instanceof Objective){
    //   state.subjects[index].merge(data)
    //   let objctive = state.subjects.find(item => item instanceof Objective)
    //   console.log('onjective--------------log', objctive);
    //   objctive && (objctive.items = [...objctive.items.concat(data.items)])
    //   ret
    // }
    state.THS.splice(state.subjects[index].thIndex, 0, state.subjects[index].historyTH);
    state.THS.splice(state.THS.indexOf(data.th), 1);
    state.THS = [...new Set(state.THS)].sort((a, b) => {
      return THSObj[a] - THSObj[b];
    }); // 处理题型的题号问题
    data.thIndex = state.THS.indexOf(data.th);
    state.subjects[index] = data;
    const obj = state.subjects;
    state.subjects = [];
    state.subjects = obj;
  },
  sortSubjectByIndex: (state, payload) => {
    const {
      newIndex,
      oldIndex
    } = payload;
    const currentSubject = state.subjects.splice(oldIndex, 1)[0];
    currentSubject && state.subjects.splice(newIndex, 0, currentSubject);
  }

};

function getContentHeight(acCardStudentCodeType) {
  // return CONTENT_HEIGHT
  let gap = 0
  let card = document.querySelector('.basics-card')
  switch (Number(acCardStudentCodeType)) {
    case 2: // 手写
      return PAGE_CELL_HEIGHT - 122 - gap
      break;
    case 4: // 涂点+条码
      return PAGE_CELL_HEIGHT - 402 - gap
      break;
    case 5: // 手写2
      return PAGE_CELL_HEIGHT - 320 - gap
      break;
    case 6: // 封装线
      return PAGE_CELL_HEIGHT - 66 - gap
      break;
    default:
      return CONTENT_HEIGHT
      break;
  }
}
function answerObjective(pageData) {
  let {
    fillTopiclist
  } = pageData;
  fillTopiclist.forEach((item) => {
    if (item.type == 3 && item.hasUnderline) {
      let tempItem = new AnswerModel(item)
      let html = tempItem.evergeRender(item)
      item.innerHTML = html
    }

  })
  return pageData
}
const actions = {
  setCurrentPageNum({
    commit
  }, data) {
    commit('setCurrentPageNum', data);
  },
};

const getters = {
  kMAndPeriod: state => {
    console.log("-----kMAndPeriod")
    if (!state.kMAndPeriod) {
      try {
        const km = localStorage.getItem(STATE_KEY.APP_KM_KEY)
        state.kMAndPeriod = JSON.parse(km)
      } catch (e) {
        console.error(e)
      }
    }
    return state.kMAndPeriod
  },
};

export default {
  namespaced: true, //命名空间
  state,
  getters,
  actions,
  mutations,
};